// Coalesce document-line lookups into bounded requests, sharing duplicate IDs.
const pending = new Map()
export function fetchVariantDetails(endpoint, id) {
  const url = new URL(endpoint, window.location.origin)
  const key = url.toString()
  let batch = pending.get(key)
  if (!batch) {
    batch = new Map()
    pending.set(key, batch)
    queueMicrotask(async () => {
      pending.delete(key)
      const entries = [...batch.entries()]
      for (let offset = 0; offset < entries.length; offset += 50) {
        const chunk = entries.slice(offset, offset + 50)
        const requestUrl = new URL(url)
        requestUrl.searchParams.set("details", "1")
        chunk.forEach(([variantId]) => requestUrl.searchParams.append("ids[]", variantId))
        try {
          const response = await fetch(requestUrl, { headers: { Accept: "application/json" }, credentials: "same-origin" })
          if (!response.ok) throw new Error("Unable to load item details")
          const variants = new Map((await response.json()).map(variant => [String(variant.id), variant]))
          chunk.forEach(([variantId, callbacks]) => {
            const variant = variants.get(variantId)
            if (variant) callbacks.resolve(variant)
            else callbacks.reject(new Error("This item is no longer available"))
          })
        } catch (error) { chunk.forEach(([, callbacks]) => callbacks.reject(error)) }
      }
    })
  }
  const variantId = String(id)
  if (!batch.has(variantId)) {
    let resolve, reject
    const promise = new Promise((done, fail) => { resolve = done; reject = fail })
    batch.set(variantId, { promise, resolve, reject })
  }
  return batch.get(variantId).promise
}
